import { every, get, isNull } from 'lodash';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { observer } from 'mobx-react';
import { PAYMENT_TYPES } from '@nandosaus/constants';
import { useEffect, useState } from 'react';
import { useRootStore } from '@nandosaus/state-management';
import parseBody from 'urlencoded-body-parser';
import PropTypes from 'prop-types';

import { getFeatureFlags } from '@utils/feature-flags';
import { Box, Col, Container, Row } from '../../../components/grid';
import { Breadcrumbs } from '../../../components/breadcrumbs';
import { CreateGiftCardForm } from '../../../components/create-gift-card-form';
import { getAmountValue } from '../../../components/create-gift-card-form/util';
import { Layout } from '../../../components/layout';
import { navigation } from '../../../constants';
import { OrderSummary } from '../../../components/gift-card-order-summary';
import { useFeature } from '../../../hooks/use-feature';

const CreateGiftCard = ({ title, adyen, isProcessing3dsPayment }) => {
  const [amount, setAmount] = useState('');
  const [quantity, setQuantity] = useState('1');
  const { PaymentStore, CartStore } = useRootStore();

  useEffect(() => {
    PaymentStore.loadPaymentMethods({
      restaurantId: process.env.adyen.giftCardRestaurant,
      isPurchasingGiftCard: true,
    });
  }, [PaymentStore]);

  useEffect(() => {
    CartStore.setSplitPaymentType(PAYMENT_TYPES.CREDIT_CARD);
  }, [CartStore]);

  const showDigitalGiftCard = useFeature('digital-gift-card');
  if (!showDigitalGiftCard) {
    return null;
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.recaptcha.siteKey}>
      <Layout title={title}>
        <Container flexDirection="column" mt="2rem" flex={1}>
          <>
            <Box display={{ xs: 'none', md: 'block' }}>
              <Breadcrumbs
                pt={1}
                entry={{
                  title,
                  ancestors: [{ id: 'gift-cards-page', title: 'Gift Cards', url: navigation.GIFT_CARDS }],
                }}
              />
            </Box>
            <Row flexDirection={{ _: 'column', lg: 'row-reverse' }}>
              <Box width={{ xs: 12 / 12, lg: 4 / 12 }} mb={1}>
                <OrderSummary {...{ price: getAmountValue(amount) || '0', quantity }} />
              </Box>

              <Col width={{ xs: 12 / 12, lg: 8 / 12 }}>
                <CreateGiftCardForm {...{ setAmount, amount, quantity, setQuantity, adyen, isProcessing3dsPayment }} />
              </Col>
            </Row>
          </>
        </Container>
      </Layout>
    </GoogleReCaptchaProvider>
  );
};

CreateGiftCard.propTypes = {
  title: PropTypes.string,
  isProcessing3dsPayment: PropTypes.bool,
  adyen: PropTypes.shape({
    MD: PropTypes.string,
    PaRes: PropTypes.string,
  }),
};

CreateGiftCard.defaultProps = {
  title: undefined,
  isProcessing3dsPayment: false,
  adyen: {
    MD: null,
    PaRes: null,
  },
};

export const getServerSideProps = async ({ req, query }) => {
  const title = 'Create Gift Card';
  const featureFlags = await getFeatureFlags();

  const body = await parseBody(req);
  const MD = get(query, 'MD') || get(body, 'MD', null);
  const PaRes = get(query, 'PaRes') || get(body, 'PaRes', null);
  const isProcessing3dsPayment = every([MD, PaRes], value => !isNull(value));

  return {
    props: {
      isProcessing3dsPayment,
      adyen: { MD, PaRes },
      title,
      featureFlags,
    },
  };
};

const ObservedCreateGiftCard = observer(CreateGiftCard);

export default ObservedCreateGiftCard;
